import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BWButton from '../BWButton';

export const modalActionPropType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  type: PropTypes.oneOf(['primary', 'danger', 'success', 'warning', 'blue', 'red', 'green']),
  className: PropTypes.string,
});

const ActionButton = ({ action, defaultType, outline, onClick }) => {
  if (!action) return null;

  return (
    <BWButton
      content={action.label}
      type={action.type || defaultType}
      outline={outline}
      icon={action.icon}
      loading={action.loading}
      disabled={action.disabled || action.loading}
      className={action.className}
      onClick={onClick || action.onClick}
      showContent
    />
  );
};

ActionButton.propTypes = {
  action: modalActionPropType,
  defaultType: PropTypes.string,
  outline: PropTypes.bool,
  onClick: PropTypes.func,
};

const BWModalFooter = ({
  children,
  cancelAction,
  secondaryAction,
  primaryAction,
  dangerAction,
  onCancel,
  className,
  style,
}) => (
  <footer className={classNames('bw_modal_ds_footer', className)} style={style}>
    {children || (
      <div className='bw_modal_ds_actions'>
        <ActionButton action={cancelAction} defaultType='primary' outline onClick={onCancel} />
        <ActionButton action={secondaryAction} defaultType='primary' outline />
        <ActionButton action={primaryAction} defaultType='primary' />
        <ActionButton action={dangerAction} defaultType='danger' />
      </div>
    )}
  </footer>
);

BWModalFooter.propTypes = {
  children: PropTypes.node,
  cancelAction: modalActionPropType,
  secondaryAction: modalActionPropType,
  primaryAction: modalActionPropType,
  dangerAction: modalActionPropType,
  onCancel: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default BWModalFooter;
